import {
  createFocusOutlineStyle,
  makeStyles,
  shorthands,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../../data";

type Styles = {
  card: GriffelStyle;
  shortCard: GriffelStyle;
};

const copilotLabStyles: Styles = {
  card: {
    height: "244px",
    width: "100%",
    ...shorthands.borderRadius("16px"),
    "@media (max-width: 540px)": {
      height: "222px",
    },
  },

  shortCard: {
    height: "206px",
  },
};

const inAppStyles: Styles = {
  card: {
    display: "inline-flex",
    height: "160px",
    width: "100%",
    ...shorthands.padding("16px"),
    flexDirection: "column",
    alignItems: "flex-start",
    ...shorthands.gap("16px"),
    flexShrink: 0,
    boxSizing: "border-box",
  },

  shortCard: {
    height: "122px",
  },
};

const m365Styles: Styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "216px",
    width: "auto",
    boxShadow: tokens.shadow4,
    ...shorthands.borderRadius("16px"),
    ...shorthands.gap("8px"),
    ...shorthands.padding("16px", "20px"),

    "&:hover": {
      boxShadow: tokens.shadow8,
      backgroundColor: tokens.colorNeutralForegroundInvertedHover,
      ...shorthands.border("1px", "solid", tokens.colorBrandForeground1),
    },

    ...createFocusOutlineStyle({
      selector: "focus-within",
      style: {
        outlineRadius: "16px",
        outlineOffset: {
          top: "-2px",
          bottom: "-2px",
          left: "-2px",
          right: "-2px",
        },
        outlineWidth: "2px",
      },
    }),
  },

  shortCard: {
    height: "170px",
  },
};

const singleColumnStyles: Styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    height: "160px",
    boxShadow: tokens.shadow4,
    width: "auto",
    ...shorthands.borderRadius("16px"),
    ...shorthands.gap("8px"),
    ...shorthands.padding("16px", "20px"),

    "&:hover": {
      boxShadow: tokens.shadow8,
      backgroundColor: tokens.colorNeutralForegroundInvertedHover,
      ...shorthands.border("1px", "solid", tokens.colorBrandForeground1),
    },

    ...createFocusOutlineStyle({
      selector: "focus-within",
      style: {
        outlineRadius: "16px",
        outlineOffset: {
          top: "-2px",
          bottom: "-2px",
          left: "-2px",
          right: "-2px",
        },
        outlineWidth: "2px",
      },
    }),
  },

  shortCard: {
    height: "140px",
  },
};

const useInAppStyles = makeStyles(inAppStyles);
const useCopilotLabStyles = makeStyles(copilotLabStyles);
const useM365Styles = makeStyles(m365Styles);
const useSingleColumnStyle = makeStyles(singleColumnStyles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "in-app":
      return useInAppStyles;
    case "web":
    case "web-v2":
    case "in-app-v2":
      return useCopilotLabStyles;
    case "m365":
    case "bing-web":
    case "win-copilot":
      return useM365Styles;
    case "bing-mobile":
    case "underside":
    case "single-col":
      return useSingleColumnStyle;
    default:
      return useInAppStyles;
  }
};
